import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';

import mediaWidth from '../../../utils/mediaWidth/mediaWidth';
import { Font, FontWeight } from '../../../utils/fonts';
import Color from '../../../utils/colors';

// import BlueCircle from '../../../common/BlueCircle';

const menuShow = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const menuHide = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export default class MenuButton extends Component {
    render() {
        const { className, isHidden } = this.props;

        return (
            <Root className={className}>
                {/* <BlueCircle /> */}
                <Text isHidden={isHidden}>меню</Text>
            </Root>
        );
    }
}

const Text = styled.div`
    margin-top: 8px;
    ${Font.HEADLINE};
    ${FontWeight.MEDIUM};
    color: ${Color.TEXT_PRIMARY};
    font-size: 12px;
    line-height: 14px;
    text-transform: uppercase;

    ${mediaWidth.l} {
        margin-top: 0px;
        margin-left: 16px;
        font-size: 14px;
        line-height: 16px;

        opacity: 0;
        animation-name: ${({ isHidden }) => (isHidden ? menuShow : menuHide)};
        animation-duration: 0.1s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
    };

    ${mediaWidth.xl} {
        font-size: 16px;
        line-height: 19px;
    };
`;

const Root = styled.div`
    height: 46px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content:  flex-end;
    cursor: pointer;

    ${mediaWidth.l} {
        width: 101px;
        height: 32px;

        flex-direction: row;
        justify-content: flex-end;
    };

    ${mediaWidth.xl} {
        width: 108px;
        height: 32px;
    };
`;
